import MyTable from "components/UIElements/MyTable";

export default function DeviceOverviewResults({ endPoint }) {
    const columns = [
        {
            title: 'Ημερομηνία Εισαγωγής',
            dataIndex: 'dateCreated',
            key: 'dateCreated',
        },
        {
            title: 'ΙΜΕΙ Συσκευής',
            dataIndex: 'deviceImei',
            key: 'deviceImei',
        },
        {
            title: 'ΙΜSΙ Sim Κάρτας',
            dataIndex: 'simImsi',
            key: 'simImsi',
        },
        {
            title: 'Hμ/νία Τροποποίησης',
            dataIndex: 'dateModified',
            key: 'dateModified',
        },
        {
            title: 'Αριθμός Κιβωτίου',
            dataIndex: 'parcelId',
            key: 'parcelId',
        },
        {
            title: 'Κατάσταση',
            dataIndex: 'status',
            key: 'status',
        },
        {
            title: 'DeviceType',
            key: 'deviceType',
            dataIndex: 'deviceType',
        },
    ];

    return <MyTable endPoint={endPoint}  columns={columns} style={{ cursor: "pointer" }} />
}